import { createLazyComponent, LazyModule } from 'owa-bundling';
import './orchestrators/openPremiumDashboard';
import './orchestrators/showHelpPane';
import './orchestrators/showQuickOptions';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "HeaderPane", webpackPrefetch: true */ './lazyIndex');
});
// Delay loaded components
export var DiagnosticsPane = createLazyComponent(lazyModule, function (m) { return m.DiagnosticsPane; });
export var FeatureFlagsPane = createLazyComponent(lazyModule, function (m) { return m.FeatureFlagsPane; });
export var FeatureFlagsHeader = createLazyComponent(lazyModule, function (m) { return m.FeatureFlagsHeader; });
export var FeatureFlagsList = createLazyComponent(lazyModule, function (m) { return m.FeatureFlagsList; });
export var HelpPane = createLazyComponent(lazyModule, function (m) { return m.HelpPane; });
export var MeCardPane = createLazyComponent(lazyModule, function (m) { return m.MeCardPane; });
export var SettingsPane = createLazyComponent(lazyModule, function (m) { return m.SettingsPane; });
export var FeedbackPane = createLazyComponent(lazyModule, function (m) { return m.FeedbackPane; });
export var WafflePane = createLazyComponent(lazyModule, function (m) { return m.WafflePane; });
export var GetStartedPane = createLazyComponent(lazyModule, function (m) { return m.GetStartedPane; });
export var WhatsNewPane = createLazyComponent(lazyModule, function (m) { return m.WhatsNewPane; });
export var TodoPane = createLazyComponent(lazyModule, function (m) { return m.TodoPane; });
//# sourceMappingURL=index.js.map